import { cacheAsset } from '@/utils/cache';
import { useQueries } from '@tanstack/react-query';
import { useRef } from 'react';

export function useCacheAssets(urls: string[]) {
  // Keep track of which URLs we've already started loading
  const loadedUrls = useRef(new Set<string>());
  // Add state for debounced loading

  const { cacheResults, isLoadingCacheResults } = useQueries({
    queries: urls.map((url) => ({
      queryKey: ['slide-asset', url],
      queryFn: () => {
        loadedUrls.current.add(url);
        return cacheAsset(url);
      },
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      suspense: false,
      enabled: true,
    })),
    combine: (results) => {
      const isLoading = results.some((result) => result.isLoading);
      return {
        cacheResults: results,
        isLoadingCacheResults: isLoading,
      };
    },
  });

  return {
    cacheResults,
    isLoadingCacheResults,
  };
}
